/**
 * Item ownership vs creator (record metadata):
 * - `resolveItemCreatorUid`: who created the row (`createdBy` / submitter fields). Unchanged by delegation.
 * - `resolveItemOwnerUid`: effective owner for ACL checks — `ownedBy` when set (delegated owner), else creator.
 * Delegation grants the delegatee owner-level permissions; it does not rewrite `createdBy`.
 */
export function resolveItemOwnerUid(
  row: Record<string, unknown> | null | undefined
): string | undefined {
  if (!row || typeof row !== "object") {
    return undefined
  }
  const owned = row.ownedBy
  if (owned != null && String(owned).trim() !== "") {
    return String(owned).trim()
  }
  return resolveItemCreatorUid(row)
}

/** Submitter / creator only (ignores `ownedBy`), for original creator checks. */
export function resolveItemCreatorUid(
  row: Record<string, unknown> | null | undefined
): string | undefined {
  if (!row || typeof row !== "object") {
    return undefined
  }
  const v = row._submitterUserId ?? row.createdBy ?? row._createdBy
  if (v === undefined || v === null) return undefined
  const s = String(v).trim()
  return s || undefined
}

export function uidsEqual(
  a: string | undefined | null,
  b: string | undefined | null
): boolean {
  if (a == null || b == null) return false
  const sa = String(a).trim()
  const sb = String(b).trim()
  return sa.length > 0 && sa === sb
}

export function hasDelegatedOwner(row: Record<string, unknown> | null | undefined): boolean {
  if (!row || typeof row !== "object") {
    return false
  }
  const owned = row.ownedBy
  return owned != null && String(owned).trim() !== ""
}
